export default "/_next/static/images/05f0e29369a0fca3109cbcee3bd31219.png";